module.exports = __webpack_public_path__ + "media/images/bookings/childcare/supervisor-6ab5375e1f03e9b348e77e504620d637.jpg";